<template>
  <dropdown :is-active.sync="isActive">
    <text-field :label="label" :placeholder="placeholder" :clearOnBlur="true"
      v-model="text" @keyup="onKeyup" @focus="onFocus" :error="error" @blur="onBlur"
      @text="onText" />
    <template slot="dropdown-content">
      <slot></slot>
    </template>
  </dropdown>
</template>

<script>
import Dropdown from '@/components/general/dropdown'
import TextField from '@/components/general/tag-text-field'

export default {
  components: { TextField, Dropdown },
  props: {
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    value: {
      type: Array
    },
    showSuggestions: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    }
  },
  computed: {
    text: {
      get () { return this.value },
      set (value) { return this.$emit('input', value) }
    },
    isActive: {
      get () { return this.showSuggestions },
      set (value) { return this.$emit('update:showSuggestions', value) }
    }
  },
  methods: {
    onKeyup (event) {
      this.$emit('keyup', event)
    },
    onBlur (event) {
      this.$emit('blur', event)
    },
    onFocus (event) {
      this.$emit('focus', event)
    },
    onText (event) {
      this.$emit('text', event)
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown,
.dropdown-trigger {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/general/autocomplete-tag-field.vue